import React from 'react';
import { IMAGE_PRESETS } from './presets';
import { buildImageSrcSet, getFallbackImageSrc } from './utils';

const BaseImage = ({
  image,
  preset,
  alt,
  className,
  loading,
  style,
  sizes,
  ...props
}) => {
  const presetConfig = IMAGE_PRESETS[preset] || IMAGE_PRESETS.default;
  const resolvedLoading = loading || presetConfig.loading || 'lazy';
  const resolvedSrc = getFallbackImageSrc(image, presetConfig.src);
  const resolvedSrcSet = buildImageSrcSet(image);
  const resolvedSizes = sizes || presetConfig.sizes;

  if (!resolvedSrc) {
    return null;
  }

  return (
    <img
      src={resolvedSrc}
      srcSet={resolvedSrcSet || undefined}
      sizes={resolvedSrcSet ? resolvedSizes : undefined}
      alt={alt || image?.name || ''}
      className={className}
      loading={resolvedLoading}
      decoding="async"
      style={{
        objectFit: presetConfig.objectFit,
        borderRadius: presetConfig.round ? '50%' : undefined,
        ...style,
      }}
      {...props}
    />
  );
};

export const Image = React.memo(BaseImage);

export { IMAGE_PRESETS } from './presets';
export { buildImageSrcSet, getFallbackImageSrc } from './utils';
